module.exports = __webpack_public_path__ + "img/button-click.045e1659.gif";